import {
    scoreDecompositionCharts,
    scoreDecompositionStartPointValueMapping
} from 'utils/charts/constants';
import {
    getActiveBarCountAndHighestScore,
    generateGraphicForCorrelation,
    generateGraphicsForScenario
} from 'utils/charts/rmCard/scoreDecomposition';

export const scoreDecompositionChartOptions = (rmData) => {
    if (!rmData) return;

    const { highestScore, activeBarCount } = {
        ...getActiveBarCountAndHighestScore(rmData)
    };
    const getLabelGraph = () => {
        let index = -1;

        const startPointValue =
            scoreDecompositionStartPointValueMapping[activeBarCount];
        return scoreDecompositionCharts.map((config) => {
            if (rmData[config.score] > 0) {
                const fiftyPercentMark = highestScore * 0.5;
                const twentyFivePercentMark = highestScore * 0.25;
                const eightyFivePercentMark = highestScore * 0.85;
                const additionalSpace = () => {
                    const rmScore = rmData[config.score];
                    if (rmScore === highestScore) return 5;
                    if (rmScore < twentyFivePercentMark) return 12;
                    if (
                        rmScore >= twentyFivePercentMark &&
                        rmScore < fiftyPercentMark
                    )
                        return 10;
                    if (
                        rmScore >= fiftyPercentMark &&
                        rmScore < eightyFivePercentMark
                    )
                        return 7;
                    if (rmScore >= eightyFivePercentMark) return 6;
                };
                const left =
                    (rmData[config.score] / highestScore) * 215 +
                    additionalSpace();

                index += 1;
                return config.score === 'correlationScore'
                    ? generateGraphicForCorrelation({
                          config,
                          startPointValue,
                          index,
                          rmData,
                          left
                      })
                    : generateGraphicsForScenario({
                          config,
                          startPointValue,
                          index,
                          rmData,
                          left
                      });
            }
        });
    };

    const getSeriesData = () => {
        let series = [];

        scoreDecompositionCharts.map((config) => {
            if (config.key === 'Correlation') {
                series.push({
                    type: 'bar',
                    data: [rmData[config.score]],
                    label: {
                        show: false
                    },
                    color: config.color,
                    barWidth: 54,
                    barGap: '0%'
                });
            } else if (rmData[config.score] > 0) {
                series.push({
                    type: 'bar',
                    data: [rmData[config.score]],
                    label: {
                        show: false
                    },
                    color: config.color,
                    barWidth: 54,
                    barGap: '0%'
                });
            }
        });

        return series;
    };

    return {
        title: {
            left: 'left',
            text: 'Risk Score Decomposition',
            textStyle: {
                color: '#244B60',
                fontSize: '12px'
            }
        },
        grid: {
            height: '80%',
            width: '215px',
            top: '10%',
            left: 0,
            containLabel: true
        },
        yAxis: [
            {
                type: 'category',
                data: [''],
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                }
            }
        ],
        xAxis: {
            axisLine: {
                show: false
            },
            axisLabel: {
                show: false
            },
            splitLine: {
                show: false
            },
            min: 0,
            max: highestScore
        },
        series: getSeriesData(),
        graphic: getLabelGraph().flat()
    };
};
